export const AUTO_REGISTRATION_QUERY_NAME = 'auto-registration';
